import avatar1 from '../../../../../../assets/images/lg/avatar1.jpg';
import avatar2 from '../../../../../../assets/images/lg/avatar2.jpg';
import avatar3 from '../../../../../../assets/images/lg/avatar3.jpg';
import avatar4 from '../../../../../../assets/images/lg/avatar4.jpg';
import avatar5 from '../../../../../../assets/images/lg/avatar5.jpg';
import avatar6 from '../../../../../../assets/images/lg/avatar6.jpg';
import avatar7 from '../../../../../../assets/images/lg/avatar7.jpg';
import avatar8 from '../../../../../../assets/images/lg/avatar8.jpg';
import avatar9 from '../../../../../../assets/images/lg/avatar9.jpg';

export const empSalaryColumns = [
    {
      Header: 'Id',
      accessor: 'id',
    },
    {
      Header: 'Name',
      accessor: 'name',
    },
    {
      Header: 'Phone',
      accessor: 'phone',
    },
    {
      Header: 'Join Date',
      accessor: 'joinDate',
    },
    {
      Header: 'Role',
      accessor: 'role',
    },
    {
      Header: 'Salary',
      accessor: 'salary',
    },
    {
      Header: 'Action',
      accessor: 'action',
    }
  ];

  export const empSalaryTableData = [
    {   
        id:'LA-0212',
        name:'Debra Stewart',
        email:'debra_stewart@gmail.com',
        phone:'+ 264-625-2583',
        joinDate: '19 March, 2023',
        role: 'Event Coordinator',
        salary: '$589',
        empImg: avatar1,
    },
    {   
        id:'LA-0213',
        name:'Francisco Vasquez',
        email:'francisco_vasquez@gmail.com',
        phone:'+ 264-625-2583',
        joinDate: '18 March, 2023',
        role: 'Concierge',
        salary: '$157',
        empImg: avatar2,
    },
    {   
        id:'LA-0214',
        name:'Jane Hunt',
        email:'jane_hunt@gmail.com',
        phone:'+ 264-625-2583',
        joinDate: '14 March, 2023',
        role: 'Housekeeping Staff',
        salary: '$425',
        empImg: avatar3,
    },
    {   
        id:'LA-0215',
        name:'Darryl Day',
        email:'darryl_day@gmail.com',
        phone:'+ 264-625-2583',
        joinDate: '08 March, 2023',
        role: 'Concierge',
        salary: '$520',
        empImg: avatar4,
    },
    {   
        id:'LA-0216',
        name:'Jeffrey Warden',
        email:'jeffrey_warden@gmail.com',
        phone:'+ 264-625-2583',
        joinDate: '11 March, 2023',
        role: 'Security Manager',
        salary: '$455',
        empImg: avatar5,
    },
    {   
        id:'LA-0217',
        name:'Bernardo Galaviz',
        email:'bernardo_galaviz@gmail.com',
        phone:'+ 264-625-2583',
        joinDate: '27 Feb, 2023',
        role: 'Housekeeping Staff',
        salary: '$865',
        empImg: avatar6,
    },
    {   
        id:'LA-0218',
        name:'Alice Collins',
        email:'alice_collins@gmail.com',
        phone:'+ 264-625-2583',
        joinDate: '24 March, 2023',
        role: 'Receptionist',
        salary: '$145',
        empImg: avatar7,
    },
]